import { FormattedMessage } from 'react-intl';
import { ConditionalLink, PreviewImage } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

const SummaryItem = ({
  item,
  ctaText,
  hideImages,
  hideDescriptions,
  isEditMode,
  overrideImage,
  /* might be used to add an utm_source parameter for example */
  linkSuffix = '',
}) => {
  let targetLink = flattenToAppURL(item['@id']);
  if (linkSuffix?.length > 0) targetLink += linkSuffix;
  return (
    <div className="summary-item">
      {!hideImages && (
        <div className="img-wrapper">
          <ConditionalLink to={targetLink} condition={!isEditMode}>
            <PreviewImage item={overrideImage || item} alt="" />
          </ConditionalLink>
        </div>
      )}
      <div className="listing-body">
        <div className="head awh">
          <ConditionalLink to={targetLink} condition={!isEditMode}>
            {item.title ? item.title : item['@id']}
          </ConditionalLink>
        </div>
        {!hideDescriptions && item.description && (
          <div className="description">{item.description}</div>
        )}
      </div>
      <span className="cta-link">
        <ConditionalLink to={targetLink} condition={!isEditMode}>
          {ctaText || (
            <FormattedMessage id="Read more" defaultMessage="Read more" />
          )}
        </ConditionalLink>
      </span>
    </div>
  );
};

export default SummaryItem;
